<template>
  <div>
    <base-breadcrumb-bar
      :pageTitle="'Manage Duplicates'"
      :tabItems="tabs"
      :tab.sync="tab"
      :initialTab="tab"
    />

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(e, i) in tabs" :key="i">
        <duplicate-section
          v-if="tab === i"
          :field="e.field"
          :label="e.label"     
          :queryLimit="e.queryLimit"
          :search="e.search"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import DuplicateSection from "@/components/Base/Duplicates/DuplicateSection";

export default {
  name: "Duplicates",
  components: { DuplicateSection },
  data() {
    return {
      tabs: [
        {
          text: "Emails",
          icon: "fi fi-rr-envelope",
          field: "email",
          label: "Email",
          queryLimit: { description: "Emails" },
          search: {},
        },
        {
          text: "Cell Numbers",
          icon: "fi fi-rr-mobile-button",
          field: "altNumber",
          label: "Number",
          queryLimit: { description: "Phones" },
          search: {},
        },
      ],
      tab: 0,
    };
  },
};
</script>
